



















































import { useUser } from '@checkout/composables';
import RequiredFieldsNote from '@checkout-atoms/required-fields-note/RequiredFieldsNote.vue';
import WillSendConfirmationMessage from '~/diptyqueTheme/components/atoms/WillSendConfirmationMessage.vue';
import { FormGenerator } from '@form-generator';
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';

import { useConfig, useOptins } from '~/composables';

import { useRegistrationForm } from './composables';

export default defineComponent({
  name: 'UserRegistrationForm',
  components: {
    RequiredFieldsNote,
    FormGenerator,
    WillSendConfirmationMessage
  },
  setup() {
    const { optins } = useOptins();
    const { config } = useConfig();
    const isNewsletterChecked = ref(false);

    const {
      formFields,
      formData,
      isEmailRecognized,
      showEmailRecognitionMessage
    } = useRegistrationForm();
    const {
      register,
      loading: { register: loading }
    } = useUser();

    const onFormSubmit = async () => {
      await register(formData.value);
    };
    const isNewsletterConfirmationNeeded = computed(
      () => config.value?.newsletter_subscription_confirm && isNewsletterChecked.value
    );
    const inputChanged = function (inputData) {
      isNewsletterChecked.value = inputData.optin_newsletter;
    };

    return {
      inputChanged,
      isNewsletterConfirmationNeeded,
      formData,
      formFields,
      onFormSubmit,
      loading,
      optins,
      isEmailRecognized,
      showEmailRecognitionMessage
    };
  }
});
